import styled from 'styled-components'
import { flexbox, grid, layout, margin, padding, position } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { BLUEPRINT_WIDTH, PADDING_X } from 'Constants/Landing'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.attrs({
  py: [6, 6, 6, 15],
  px: PADDING_X,
})`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  justify-content: center;
  background-color: ${themeGet('colors.bg.almond')};
  overflow: hidden;

  ${padding}
`

export const Content = styled.div
  .attrs({
    alignItems: ['flex-start', 'flex-start', 'center'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${BLUEPRINT_WIDTH}px;

  ${flexbox}
`

export const ImageHolder = styled.div`
  display: flex;
  width: 580px;
  height: 572px;
  flex-shrink: 0;

  img {
    border-radius: 20px;
    width: 100%;
    height: 100%;
  }
`

export const DotsContainer = styled.div
  .attrs({
    top: [-40],
    right: [-40],
    display: ['none', 'none', 'flex'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  position: absolute;
  z-index: 0;

  ${position}
  ${layout}
`

export const CardContainer = styled.div
  .attrs({
    gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr', 'repeat(3, 1fr)'],
    gridGap: ['72px', '72px', '72px', '72px', '30px', '20px'],
  })
  .withConfig({
    shouldForwardProp,
  })`
  display: grid;
  width: 100%;
  position: relative;

  ${grid}
  ${margin}
`

export const Card = styled.div.attrs({
  pt: [17, 17, 19],
  px: [7, 7, 9],
  pb: [9, 9, 12],
})`
  background-color: ${themeGet('colors.bg.default')};
  border-radius: 20px;
  position: relative;

  > svg {
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    width: 80px;
    height: 80px;

    @media screen and (min-width: ${themeGet('breakpoints.2')}) {
      width: 100px;
      height: 100px;
    }
  }

  ${padding}
`
